import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from '@/utils';
export default {
  name: 'yanchu_goods_list_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      typeList: [],
      menusMap: {}
    };
  },
  computed: {
    menuListFilter: function menuListFilter() {
      var menus_yanchu = this.menuList.filter(function (i) {
        return i.type === 'yanchu';
      });
      this.menusMap = this.buildChildrenMap(menus_yanchu); // 以id为键 列出childrens枚举
      return menus_yanchu;
    }
  },
  methods: {
    changeType: function changeType(item) {
      this.value.config.show_type = item.id;
    },
    checkNumber: function checkNumber(rule, value, callback) {
      if (value === '') {
        return callback('商品展示行数不可为空');
      } else {
        if (!/^[0-9]*$/.test(value)) {
          callback('仅支持正整数');
        } else if (value > 199 || value < 1) {
          callback('仅支持1-199正整数');
        } else {
          callback();
        }
      }
    },
    checkList: function checkList(type, value, callback, flag) {
      if (flag && isEmpty(value)) {
        callback("".concat(type === 'sub_name' ? '副标题' : '展示名称', "\u4E0D\u53EF\u4E3A\u7A7A"));
      }
      if (this.value.config.value.some(function (i) {
        return i.flag == true;
      })) {
        callback();
      } else {
        callback('请给要展示的分类选择菜单');
      }
    },
    changeCategory: function changeCategory(val) {
      if (val) {
        var menu = this.menusMap[val] || [];
        var children = menu.map(function (i) {
          return _objectSpread(_objectSpread({}, i), {}, {
            primitiveName: i.name,
            sub_name: '',
            flag: true
          });
        });
        this.value.config.value = children || [];
      } else {
        this.value.config.value = [];
      }
    },
    buildChildrenMap: function buildChildrenMap(arr) {
      var map = {};
      function recurse(items) {
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            map[item.id] = item.childrens || [];
            if (item.childrens && item.childrens.length > 0) {
              recurse(item.childrens);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      recurse(arr);
      return map;
    }
  },
  created: function created() {
    var _this$tabListFlat$fin,
      _this = this;
    var _ref = ((_this$tabListFlat$fin = this.tabListFlat.find(function (i) {
        return i.key === _this.value.key;
      })) === null || _this$tabListFlat$fin === void 0 ? void 0 : _this$tabListFlat$fin.config_default_value) || {},
      _ref$typeList = _ref.typeList,
      typeList = _ref$typeList === void 0 ? [] : _ref$typeList;
    this.typeList = typeList;
    this.$set(this.value, 'config', _objectSpread({
      category_id: '',
      extend_sort: 1,
      sort: '3',
      line_number: 5,
      list_show_type: 1,
      //列表展示样式 1-固定行数商品 2-上滑无限加载商品
      list_show_more: 1,
      //是否显示加载更多 0-不显示 1-显示,
      show_type: this.value.show_type || 1,
      // 兼容新老组件 默认预置类型为图片是图
      is_open_sub_name: '0',
      //兼容新老组件 默认预置关闭
      is_show_title: 1,
      //兼容新老组件 默认预置显示
      margin_top: 15,
      //兼容新老组件 默认预置15px
      z_index: 2
    }, this.value.config));
  }
};